import { useUser } from 'context/userContext';

const useCheckUserRole = (allowed?: string[]) => {
  const { user } = useUser();
  const role = user.currentClinicUserRole?.role ?? user.adminRole?.role;

  const isUserNotAllowed = !!role && !!allowed && !allowed.includes(role);

  return { isUserNotAllowed };
};

export default useCheckUserRole;
